import { ThemeDialog } from "./ThemeDialog";
import React, { useState } from "react";

interface ThemeDialogTriggerProps {
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

/** Wrapper component that triggers ThemeDialog (the same one used in the side menu) */
export function ThemeDialogTrigger({ children, open, onOpenChange }: ThemeDialogTriggerProps) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = open !== undefined;
  const isOpen = isControlled ? open! : internalOpen;
  const handleOpenChange = (val: boolean) => {
    if (!isControlled) setInternalOpen(val);
    onOpenChange?.(val);
  };

  return (
    <>
      <div onClick={() => handleOpenChange(true)} style={{ display: 'contents', cursor: 'pointer' }}>
        {children}
      </div>
      <ThemeDialog open={isOpen} onOpenChange={handleOpenChange} />
    </>
  );
}